import { Button, Checkbox, Divider, ListItemIcon, ListItemText, Menu, MenuItem, Stack } from '@mui/material';
import { addTransportFilterCheckedItem, deleteTransportFilterCheckedItem, setTransportFilterCheckedItems, } from 'app/actions/map';
import { Protect } from 'app/components';
import { useLocalStorage } from 'app/services';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
const MapTransportFilterMenu = (props) => {
    const dispatch = useDispatch();
    const checkedItems = useSelector((state) => state.map.transportFilterCheckedItems);
    const session = useSelector((state) => state.session.session);
    const { open, onClose, anchorEl } = props;
    const [, setCheckedStorageItems] = useLocalStorage('transportFilterCheckedItems', []);
    const availableFilterNames = useMemo(() => config.mapTransportFilters
        .filter((filter) => !filter.hidden && session.permissions.some((permission) => filter.permissions.indexOf(permission) !== -1))
        .map((filter) => filter.name), [session.permissions]);
    const handleClickItem = (value) => dispatch(checkedItems.indexOf(value) !== -1 ? deleteTransportFilterCheckedItem(value) : addTransportFilterCheckedItem(value));
    const handleSelectAll = (event) => {
        event.preventDefault();
        event.stopPropagation();
        dispatch(setTransportFilterCheckedItems(availableFilterNames));
    };
    const handleDeselectAll = (event) => {
        event.preventDefault();
        event.stopPropagation();
        dispatch(setTransportFilterCheckedItems([]));
    };
    useEffect(() => {
        setCheckedStorageItems(checkedItems);
    }, [checkedItems, setCheckedStorageItems]);
    return (React.createElement(Menu, { open: open, onClose: onClose, anchorEl: anchorEl, PaperProps: {
            sx: (theme) => ({
                marginTop: theme.spacing(1.5),
                '&:before': {
                    right: '10px',
                },
            }),
        }, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
        }, sx: (theme) => ({
            '.MuiListItemIcon-root': {
                minWidth: '26px!important',
            },
            '.MuiCheckbox-root': {
                padding: theme.spacing(0),
                marginLeft: theme.spacing(0),
                svg: {
                    fontSize: '18px',
                },
            },
        }) },
        React.createElement(Stack, { direction: 'row', spacing: 1, sx: (theme) => ({
                px: theme.spacing(1.5),
                py: theme.spacing(1),
            }), onClick: (event) => event.stopPropagation() },
            React.createElement(Button, { size: 'small', onMouseDown: (event) => event.preventDefault(), onClick: handleDeselectAll }, "\u0423\u0431\u0440\u0430\u0442\u044C \u0432\u0441\u0435"),
            React.createElement(Button, { size: 'small', onMouseDown: (event) => event.preventDefault(), onClick: handleSelectAll }, "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0441\u0451")),
        React.createElement(Divider, null),
        config.mapTransportFilters.map((column) => (React.createElement(Protect, { key: column.name, permissions: column.permissions, renderPermitted: () => column.hidden ? null : (React.createElement(MenuItem, { disableRipple: true, onClick: () => handleClickItem(column.name) },
                React.createElement(ListItemIcon, null,
                    React.createElement(Checkbox, { size: 'small', edge: 'start', tabIndex: -1, disableRipple: true, checked: checkedItems.indexOf(column.name) !== -1 })),
                React.createElement(ListItemText, null, column.label))), renderForbidden: () => null })))));
};
export default MapTransportFilterMenu;
